const STORE_ID = "ESQUECEU_SENHA";

const TYPES = {
    ESQUECEU_SENHA: "ESQUECEU_SENHA",
    SET_INVALID: "SET_INVALID",
    CLEAN_ITEM: "CLEAN_ITEM",
    SET_LOADING_ESQUECEU_SENHA: "SET_LOADING_ESQUECEU_SENHA"
}

export { STORE_ID, TYPES }